/* unplugin-vue-components disabled */import { render } from "./xinput.vue?vue&type=template&id=b2c29064"
import script from "./xinput.vue?vue&type=script&lang=jsx"
export * from "./xinput.vue?vue&type=script&lang=jsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__